import {
  EDIT_EMAIL_FORGOT, RESET_FORGOT_FORM, REQUEST_RESET_PASSWORD,
  REQUEST_RESET_PASSWORD_SUCCESS, REQUEST_RESET_PASSWORD_FAILED
} from "../actions/forgot_form_actions";


const initialState = {
  email: '',
  requestProgress: false,
  requestFailed: false,
}

export const forgotFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_EMAIL_FORGOT: {
      return {
        ...state,
        email: action.email
      }
    }
    case RESET_FORGOT_FORM: {
      return {
        ...state,
        email: ''
      }
    }
    case REQUEST_RESET_PASSWORD: {
      return {
        ...state,
        requestProgress: true,
        requestFailed: false,
      }
    }
    case REQUEST_RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: false,
      }
    }
    case REQUEST_RESET_PASSWORD_FAILED: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: true,
      }
    }
    default: return state;
  }
}
